// Auto-generated by pipeline
export const firebaseConfig = {
  "authDomain": "iquilibre-c9ebb.firebaseapp.com",
  "projectId": "iquilibre-c9ebb",
  "storageBucket": "iquilibre-c9ebb.appspot.com",
  "messagingSenderId": "916796416933",
  "appId": "1:916796416933:web:9fa10bd667722fcff4be4c",
  "measurementId": "G-L7L3FE04FP",
  "apiKey": "AIzaSyBbJ7pgeBSysKXF96j3E7t-aN7ab6v2_B4"
};
